import { render, staticRenderFns } from "./DepartmentsTypesConfigurationModal.vue?vue&type=template&id=7e203640&"
import script from "./DepartmentsTypesConfigurationModal.vue?vue&type=script&lang=js&"
export * from "./DepartmentsTypesConfigurationModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports